import React, { Fragment } from 'react';

import Spinner from 'react-bootstrap/Spinner';

const LoadingOverlay = ({ show }) => {
  return show && (
    <Fragment>
      <div className="fade modal-backdrop show" />
      <div className="fixed-top top-50 start-50">
        <Spinner animation="border">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </Fragment>
  );
}

export default LoadingOverlay;
